import { Controller } from 'stimulus'

/**
 * Expandable analytics info panel (truncated intro + plus control, Bootstrap collapse body).
 * Reuse on any corporate analytics page: set data-controller="analytics-info-panel" on the
 * root element and wire targets / triggers as in corporation/analytics/_analytics_info_panel.
 */
export default class extends Controller {
  static targets = ['icon', 'collapse']

  connect() {
    this.introFullEl = this.element.querySelector('[data-target="analytics-info-panel.full"]')
    this.introTruncatedEl = this.element.querySelector('[data-target="analytics-info-panel.truncated"]')
    this.boundOnShown = this.onShown.bind(this)
    this.boundOnHidden = this.onHidden.bind(this)
    this.collapseTarget.addEventListener('shown.bs.collapse', this.boundOnShown)
    this.collapseTarget.addEventListener('hidden.bs.collapse', this.boundOnHidden)

    this.triggerElements = this.element.querySelectorAll('[data-analytics-info-panel-trigger]')
  }

  disconnect() {
    this.collapseTarget.removeEventListener('shown.bs.collapse', this.boundOnShown)
    this.collapseTarget.removeEventListener('hidden.bs.collapse', this.boundOnHidden)
  }

  toggle(event) {
    if (event) event.preventDefault()
    const Collapse = window.bootstrap && window.bootstrap.Collapse
    if (!Collapse) return
    Collapse.getOrCreateInstance(this.collapseTarget).toggle()
  }

  toggleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    this.toggle(event)
  }

  onShown() {
    this.iconTarget.classList.add('expanded')
    this.setExpandedAria(true)
    this.swapIntro(true)
  }

  onHidden() {
    this.iconTarget.classList.remove('expanded')
    this.setExpandedAria(false)
    this.swapIntro(false)
  }

  setExpandedAria(expanded) {
    const value = expanded ? 'true' : 'false'
    this.triggerElements.forEach((el) => el.setAttribute('aria-expanded', value))
  }

  swapIntro(expanded) {
    if (!this.hasIntroSwap()) return
    if (expanded) {
      this.introFullEl.classList.remove('visually-hidden')
      this.introTruncatedEl.classList.add('visually-hidden')
    } else {
      this.introFullEl.classList.add('visually-hidden')
      this.introTruncatedEl.classList.remove('visually-hidden')
    }
  }

  hasIntroSwap() {
    return this.introFullEl && this.introTruncatedEl
  }
}
